<template>
    <section id="lote">
        <div class="imagem" :style="{ 'background-image': 'url(' + background + ')' }"></div>

        <div class="informacoes">
            <div class="titulo">
                <h2>{{ titulo }}</h2>
                <p>Válido até o dia: {{ data.ate }}</p>
            </div>
            <div class="inclui">
                <p class="titulo">O pacote SM inclui:</p>
                <ul>
                    <li>- Acesso a todas as aulas</li>
                    <li>- Os 2 bailes principais, 25 (sexta) e 26 (sábado)</li>
                    <li>- Certificado Samba Maníacos 2020</li>
                </ul>
            </div>

            <div class="botao">
                <p>Adiquira já a sua vaga por tempo limitado!</p>
                <p class="preco"><small>R$</small>{{ preco }}</p>
                <a href="/checkout" class="btn btn-success">{{ nomeBotao() }}</a>
            </div>
            <!-- <div class="pacote-bailes">
                <p class="titulo">Pacote de bailes</p>
                <p>Adiquira já o pacote com todos os 4 bailes por apenas R$ 130,00</p>
                <p>Obs: Apenas para quem <strong>não</strong> adquiriu o pacote SM!</p>
                <br>
                <p>Se você já é um Maníaco 2020, pode estar adquirindo as entradas de quinta e domigo na portaria do evento!</p>
                <a href="" class="btn btn-outline-secondary">
                    Pacote de bailes
                </a>
            </div> -->
        </div>

        <div class="parallax-section">
            <div class="parallax-child-section">
                <section class="fw-main-row" :style="{ 'background-image': 'url(' + background + ')' }">
                </section>
            </div>
        </div>
    </section>
</template>

<script>
import services from '@/http'

import ImgEscuro from '@/assets/img/lote/lote-escuro.jpg'
import ImgPrimeiro from '@/assets/img/lote/lote-primeiro.jpg'
import ImgSegundo from '@/assets/img/lote/lote-segundo.jpg'
import ImgTerceiro from '@/assets/img/lote/lote-terceiro.jpg'
import ImgQuarto from '@/assets/img/lote/lote-quarto.jpg'

import JsonListaMeses from '@/assets/json/listaMeses.json'

export default {
    data () {
        return {
            imagens: {
                escuro: ImgEscuro,
                primeiro: ImgPrimeiro,
                segundo: ImgSegundo,
                terceiro: ImgTerceiro,
                quarto: ImgQuarto
            },
            background: '',
            titulo: '',
            data: {
                de: '',
                ate: ''
            },
            preco: '',
            meses: JsonListaMeses
        }
    },
    methods: {
        /**
         * Personaliza o nome do botão!
         */
        nomeBotao () {
            return 'Comprar ' + (this.titulo.toLowerCase() || 'agora!')
        },

        /**
         * Converte o formato mm-dd-yyyy para dd de M
         */
        convertData (date) {
            let _date = date.split('-')
            return _date[2] + ' de ' + this.meses[_date[1]].toLowerCase()
        }
    },
    async mounted () {
        const produtosPromisse = services.produtos.ativo()

        await produtosPromisse.then(res => {
            let _data = res.data.data

            let data = {
                background: _data.imagem || this.imagens.primeiro,
                titulo: _data.nome,
                dataDe: this.convertData(_data.dataInicio),
                dataAte: this.convertData(_data.dataFinal),
                preco: _data.valor.replace(/.([^.]*)$/, ',$1')
            }

            this.background = data.background
            this.titulo = data.titulo
            this.data.de = data.datDe
            this.data.ate = data.dataAte
            this.preco = data.preco
        }).catch(err => {
            console.error('Error: ', err)
        })
    }
}
</script>
<style lang="sass">
    @import '../../../assets/sass/_mixin'
    #lote
        display: flex
        height: auto
        min-height: 100vh
        position: relative
        @include device(mobile)
            &
                padding-bottom: 200px
        .imagem
            width: 50%
            background-size: cover
            background-position: top center
            @include device(mobile)
                &
                    display: none
        .parallax-section
            display: none
            @include device(mobile)
                &
                    display: block
            .parallax-child-section
                width: 100%
                height: 200px
                @include device(mobile)
                    &
                        clip: rect(0,auto,auto,0)
                        position: absolute
                        bottom: 0
                        left: 0
                .fw-main-row
                    background-position: center center
                    background-repeat: no-repeat
                    background-size: cover
                    height: 200px
                    width: 100%
                    background-attachment: fixed
                    padding: 0rem
                    @include device(mobile)
                        &
                            position: fixed
                            display: block
                            top: 0
                            left: 0
                            height: 100%!important
                            transform: translateZ(0)
                            will-change: transform
                            z-index: 1
                            background-attachment: scroll!important

        .informacoes
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            width: 50%
            margin-left: auto
            padding: 25px 0
            @include device(mobile)
                &
                    width: 100%
                    padding: 50px 0
            p
                margin-bottom: 0
                text-align: center
            > div
                margin: 10px 0
                &.titulo
                    h2
                        text-align: center
                        margin-bottom: 10px
                    p
                        font-size: 18px
                &.inclui
                    border-bottom: 1px solid gainsboro
                    border-top: 1px solid gainsboro
                    padding: 20px
                    p.titulo
                        margin-bottom: 10px
                        font-weight: 600
                    ul
                        margin: 0
                        padding: 0
                        li
                            list-style-type: none
                &.botao
                    a
                        height: 55px
                        width: 300px
                        border-radius: 150px
                        @include device(mobile)
                            &
                                width: 90%
                                margin: 0 auto
                    p.preco
                        font-weight: 600
                        margin-top: 15px
                        margin-bottom: 15px
                        font-size: 35px
                        color: #00731a
                        small
                            font-size: 14px
                            margin-right: 5px
            .preco
                font-size: 30px
</style>
